import userProfile from 'shared/config/userProfile'

export const isUserEditable = (
  perfil: string,
  recordPerfil: string,
): boolean => {
  switch (perfil) {
    case userProfile.status.master:
      return true
    case userProfile.status.admin:
      if (recordPerfil === perfil) return false
      if (recordPerfil === userProfile.status.operacional) return true

      return true
    case userProfile.status.operacional:
      return false
  }
}
